module.exports = __webpack_public_path__ + "media/images/header-52d9908a562d79ea9bacc5bc78b2ba44.jpg";